<template>
  <li class="context__menu-item">
    <a
      class="context__menu-item-link"
      @click="
        () => {
          if (deactivated) {
            $refs.paidFeaturesModal.show()
          } else {
            $refs.inviteModal.show()
          }
        }
      "
    >
      <i class="context__menu-item-icon baserow-icon-team"></i>
      {{ $t('memberRolesDatabaseContexItem.label') }}
      <div v-if="deactivated" class="deactivated-label">
        <i class="iconoir-lock"></i>
      </div>
    </a>
    <InviteModal ref="inviteModal" :workspace="workspace" :target="target" />
    <PaidFeaturesModal
      ref="paidFeaturesModal"
      initial-selected-type="rbac"
      :workspace="database.workspace"
    ></PaidFeaturesModal>
  </li>
</template>

<script>
import InviteModal from '@baserow/modules/core/components/invitation/InviteModal'
import EnterpriseFeatures from '@baserow_enterprise/features'
import PaidFeaturesModal from '@baserow_premium/components/PaidFeaturesModal'

export default {
  name: 'MemberRolesViewContextItem',
  components: { PaidFeaturesModal, InviteModal },
  props: {
    table: {
      type: Object,
      required: true,
    },
    view: {
      type: Object,
      required: true,
    },
    database: {
      type: Object,
      required: true,
    },
  },
  computed: {
    workspace() {
      return this.$store.getters['workspace/get'](this.database.workspace.id)
    },
    target() {
      return {
        type: 'scope',
        scopeType: 'database_view',
        scope: this.view,
        database: this.database,
        table: this.table,
      }
    },
    deactivated() {
      return !this.$hasFeature(
        EnterpriseFeatures.RBAC,
        this.database.workspace.id
      )
    },
  },
}
</script>
